<div class="loading-container" *ngIf="show">
  <div class="circle"></div>
</div>
